module.exports = __webpack_public_path__ + "static/fcra-2019-20-q3-980894679f01d15ce213d936bd3d6ef0.pdf";